import React     from 'react';
import PropTypes from 'prop-types'

import ArrayXQty from 'pu-react/components/ArrayXQty';
import ArrayYQty from 'pu-react/components/ArrayYQty';

import SpacingX   from 'pu-react/components/SpacingXTV'
import SpacingY   from 'pu-react/components/SpacingYTV'
import ArrayRails from 'pu-react/components/ArrayRailsSidesWidth'
import ErrorLabel from 'pu-react/components/base/ErrorLabel';

const SectionNoPanelized = (props) => (
  <div>
    <div className="row">
      <div className="col-md-6">
        <ArrayXQty {...props} />
      </div>
      <div className="col-md-6">
        <SpacingX {...props} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <ArrayYQty {...props} />
      </div>
      <div className="col-md-6">
        <SpacingY {...props} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <ArrayRails {...props} />
        <ErrorLabel error={props.errors.railWidth} />
      </div>
    </div>

    <div className="alert alert-info alert-panel-size">
      Panel Size {props.parameters.array_x} x {props.parameters.array_y}
    </div>
  </div>
)

SectionNoPanelized.propTypes = {
  parameters: PropTypes.object.isRequired,
};

export default SectionNoPanelized;
